var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-table',_vm._b({ref:`${_vm.model}List`,attrs:{"enableBulkSelection":true},on:{"action":_vm.doAction,"bulkAction":_vm.doBulkAction}},'data-table',{ model: _vm.model, endpoint: _vm.endpoint },false))
}
var staticRenderFns = []

export { render, staticRenderFns }